import * as React from 'react'
import { Dialog } from 'primereact/dialog'
import { useDialogManager } from 'app/shared/hooks/dialogManager.hook'

export interface DialogProps {
    visible: boolean // 상태관리
    className: string // 클래스 추가
    maskClassName?: string
    children: React.ReactNode // 컨텐츠
    header?: React.ReactNode
    closable?: boolean // 닫기 버튼 유무
    footer?: React.ReactNode // 하단 컨텐츠
    backClose?: boolean // dim영역 선택시 닫기 유무
    closeFocus?: string // 닫기 후 포커스 이동 위치 지정
    onClose?: () => void // 닫기 시 이벤트 호출
}
const DialogCustom: React.FC<DialogProps> = ({
    header,
    visible,
    maskClassName,
    className,
    children,
    closable = true,
    footer,
    backClose = true,
    closeFocus = '',
    onClose,
}) => {
    const contentRef = React.useRef<HTMLDivElement | null>(null)
    const [internalVisible, setInternalVisible] = React.useState(false)
    const [hideClass, setHideClass] = React.useState(false)
    useDialogManager(visible) // dialog 오픈시 scoll 고정 체크
    React.useEffect(() => {
        if (visible) {
            // open
            setHideClass(false)
            setInternalVisible(true)
            setTimeout(() => {
                if (visible && contentRef.current) contentRef.current.focus()
            })
        } else if (internalVisible) {
            // hide
            setHideClass(true)
            //bottom-sheet는 에니메이션 포함이라 바로닫으면 안됌
            if (!className.includes('bottom-sheet')) {
                setInternalVisible(false)
            }
            setTimeout(() => {
                if (className.includes('bottom-sheet'))
                    setInternalVisible(false)

                if (closeFocus?.length > 0)
                    document.getElementById(closeFocus).focus()
            }, 300) // 팝업이 내려가는 시간
        }
    }, [visible])
    return (
        <>
            {internalVisible && (
                <Dialog
                    visible={true}
                    draggable={false}
                    header={<span tabIndex={0}>{header}</span>}
                    footer={footer}
                    onHide={onClose}
                    closable={closable}
                    dismissableMask={backClose}
                    maskClassName={maskClassName}
                    className={[
                        className,
                        hideClass && '-bottom-out',
                        !header ? '-hide-header' : '',
                    ].join(' ')}
                    transitionOptions={{ timeout: 0 }}
                >
                    {!header ? (
                        <div
                            ref={contentRef}
                            tabIndex={0}
                            className="p-dialog-text"
                        >
                            {children}
                        </div>
                    ) : (
                        children
                    )}
                </Dialog>
            )}
        </>
    )
}

export default DialogCustom
